<template>
    <v-form ref="form" v-model="valid" lazy-validation>
        <v-row dense>
            <v-col cols="12" sm="6" md="4" lg="4" xl="2">
                <Planes @planid-change="updatePlanIdValue" :prop-readonly="true" :propPlan="4" ref="tipoPlan"></Planes>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" xl="2">
                <TipoPago @periodo-change="updatePeriodoValue" :propPeriodo="4" ref="tipoPago" :propTipo="2"></TipoPago>
            </v-col>
            <v-col cols="12">
                <v-switch dense v-model="formData.Expedicion"
                    :label="formData.Expedicion === 1 ? 'Con gastos de expedición' : 'Sin gastos de expedición'"
                    color="primary" inset :true-value="1" :false-value="0" @change="emitirCambio"
                    hide-details></v-switch>
            </v-col>
            <v-col cols="12" >
                <v-btn-toggle v-model="porcentajeSeleccionado" dense mandatory class="d-flex flex-wrap">
                    <v-btn small :value="-15">-15%</v-btn>
                    <v-btn small :value="-10">-10%</v-btn>
                    <v-btn small :value="-5">-5%</v-btn>
                    <v-btn small :value="0">0%</v-btn>
                    <v-btn small :value="5">+5%</v-btn>
                    <v-btn small :value="10">+10%</v-btn>
                    <v-btn small :value="15">+15%</v-btn>
                </v-btn-toggle>
            </v-col>
            <v-col cols="12" xs="8" sm="6" md="2" lg="2" xl="2">
                <v-text-field v-model="formData.Precio" label="Precio producto" dense outlined
                    :rules="[v => !!v || 'Campo obligatorio']"></v-text-field>
            </v-col>

            <!-- Resultado final -->
            <v-col cols="12" xs="8" sm="6" md="4" lg="4" xl="2">
                <v-alert type="info" dense outlined>
                    <strong>Cantidad ajustada:</strong> {{ $formatCurrency(cantidadFinal.toFixed(0)) }}
                </v-alert>
            </v-col>
            <!-- Botón -->
            <v-col cols="12" class="text-right">
                <v-btn color="primary" @click="enviarDatos">
                    Renovar
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
export default {
    name: "FormRenovacionComponent",
    components: {
        Planes: () => import('@/components/selectPlanIdComponent.vue'),
        TipoPago: () => import('@/components/selectTipoPagoIdComponent.vue')
    },
    props: {
        tipoInicial: {
            type: String,
            default: "",
        },
    },
    computed: {
        cantidadFinal() {
            const base = this.formData.Precio || 0;
            const porcentaje = this.porcentajeSeleccionado || 0;
            return base + base * (porcentaje / 100);
        },
    },
    created() {
        this.getInfoRenovacion()
    },
    data() {
        return {
            valid: false,
            formData: {
                FecVig: "",
                Expedicion: 1,
                Precio: 15662.36,
                tipo: "",
                nombres: "",
                apellidoPaterno: "",
                apellidoMaterno: ""
            },
            infoReno:{

            },
            porcentajeSeleccionado: 0,

        };
    },
    methods: {
        enviarDatos() {
            if (this.$refs.form.validate()) {
                // Emite los datos al componente padre
                this.$emit("submit-form", { ...this.formData });
            }
        },
        updatePeriodoValue(idperiodo) {
            console.log(idperiodo)
        },
        updatePlanIdValue(value) {
            console.log(value)
        },
        emitirCambio() {
            console.log("emitircambio")
        },
        getInfoRenovacion() {

            this.$http.get(`membresia/infoRenovacion?membresia=${this.tipoInicial}`)
                .then(response => {
                    if (response.status === 200) {
                        this.infoReno = response.data
                        console.log(this.infoReno)
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        }
    },
};
</script>
